import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function getSettingsData(salesOrg: any) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/planning/settingsData`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch(error=>{
     // console.log(error.response.status);
      if(error.response.status==='401'){
        let exclude=[
          'SETTINGS.CLP_displayableColumns',
      'SETTINGS.CLP_filters',
      'SETTINGS.userAccess',
      'SETTINGS.CLP_column_order',
      'SETTINGS.salesOrg',
      'SETTINGS.dbSystemInd',
      'context-keys',
      'SETTINGS.PBColSequence',
      'SETTINGS.VS_PLN_column_order',
      'SETTINGS.VS_PLN_sort',
     ' SETTINGS.VS_PLN_colsize',
      'SETTINGS.VS_PLN_filters',
     ' SETTINGS.VS_PLN_displayableColumns',
     'SETTINGS.darkmode'
    ]
        
        //localStorage.clear();
        for (var key in localStorage) {
         if(!exclude.includes(key)){
          localStorage.removeItem(key);
         }
      }
        window.location.href='/'
      }
    
  
    })
}

export async function saveSettingsData(
  salesOrg:  string,
  colKey: string,
  colVal: string,
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      salesOrg,
      clientId: "100",
      colKey,
      colVal
     },
    url: `${BASE_URL}/api/planning/settingsData/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

